import { RouterModule, Routes } from "@angular/router";
import { WorklogDetailsComponent } from "./worklog-details.component";

const routes: Routes =[
    {path: ':Id', component: WorklogDetailsComponent},
    {path: 'new', component: WorklogDetailsComponent},
    {path: 'copy/:Id', component: WorklogDetailsComponent}
];

export const WorklogDetailsRouting = RouterModule.forChild(routes);